import { SVGIconComponent } from './types';

export const ChannelMobile: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="15px"
    height="26px"
    viewBox="0 0 15 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Channel/Mobile" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M2.75698764,0 L12.3242289,0 C13.7839122,0 15,1.31227686 15,2.78886487 L15,23.2111343 C15,24.7698514 13.7839392,26 12.3242289,26 L2.75698764,26 C1.21608778,26 0,24.7698787 0,23.2111343 L0,2.78886487 C0,1.31230418 1.21606078,0 2.75698764,0 Z M7.54114826,22.0631959 C8.27098993,22.0631959 8.83842557,22.7193207 8.83842557,23.4576283 C8.83842557,24.1959081 8.27098993,24.8520605 7.54114826,24.8520605 C6.73009007,24.8520605 6.16265444,24.1959357 6.16265444,23.4576283 C6.16265444,22.719348 6.73009007,22.0631959 7.54114826,22.0631959 Z M2.75698764,3.19855024 L12.3242289,3.19855024 C12.7292315,3.19855024 13.0540705,3.60823561 13.0540705,4.01898616 L13.0540705,20.0947669 C13.0540705,20.5044523 12.7292315,20.8330473 12.3242289,20.8330473 L2.75698764,20.8330473 C2.27076853,20.8330473 1.94592945,20.5044523 1.94592945,20.0947669 L1.94592945,4.01898616 C1.94592945,3.60930079 2.27076853,3.19855024 2.75698764,3.19855024 Z M6.24378996,1.31230418 L9.0007776,1.31230418 C9.48699672,1.31230418 9.48699672,2.05058452 9.0007776,2.05058452 L6.24378996,2.05058452 C5.67635433,2.05058452 5.67635433,1.31230418 6.24378996,1.31230418 Z"
        id="Fill-1"
        fill="#979797"
      ></path>
    </g>
  </svg>
);
